import { StyleSheet } from 'react-native';
import { styles as baseModalStyles } from 'src/components/modals/base-modal/BaseModal.styles';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  modal: {
    minHeight: 0,
  },
  title: {
    ...baseModalStyles.title,
    ...textLatoStyleDS.TitleBold2xl,
  },
  titleMobile: {
    ...textLatoStyleDS.TitleBoldXl,
  },
  description: {
    ...baseModalStyles.description,
    ...textLatoStyleDS.BodyRegularLg,
  },
  descriptionMobile: {
    ...textLatoStyleDS.BodyRegularMd,
  },
});
